namespace $.$$ {

	export class $shm_check_list_only extends $.$shm_check_list_only {

		checks() {
			return this.options().map( id => this.Check( id ) )
		}

		check_content( id: string ) {
			return [ this.Toggle( id ), ...( this.only_visible() ? [ this.Only( id ) ] : [] ) ]
		}

		toggles() {
			return this.options().map( id => this.Toggle( id ) )
		}

		check_title( id: string ) {
			return id
		}

		checked( id: string, next?: boolean ) {
			const value = this.value()
			if( next === undefined ) return value.includes( id )
			this.value( next
				? value.includes( id ) ? value : [ ... value, id ]
				: value.filter( selected => selected !== id )
			)
			return next
		}

		@ $mol_action
		override only( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.value([ id ])
			return next
		}

	}

}
